import { Translation } from './translations/translation';
import { ReplacementArgs } from './replacement-args';
import { TranslationPart } from './translation-part';

export class MessageTransformer {
  private translation!: Translation;
  private overrideTranslation!: Partial<Translation>;

  setTranslation(
    translation: Translation,
    overrideTranslation: Partial<Translation>
  ) {
    this.translation = translation;
    this.overrideTranslation = overrideTranslation;
  }

  transform(messagePath: string, replacements?: ReplacementArgs): string {
    const keys = messagePath.trim().split('.');
    let translation: TranslationPart | string = this.translation;
    let overrideTranslation: TranslationPart | string =
      this.overrideTranslation;

    for (const key of keys) {
      translation = translation[key];
      overrideTranslation =
        typeof overrideTranslation === 'object'
          ? overrideTranslation[key]
          : overrideTranslation;

      if (translation === undefined) {
        break;
      }
      if (typeof translation === 'string') {
        if (translation.length === 0) {
          return messagePath;
        }

        return this.replacePlaceholders(
          typeof overrideTranslation === 'string'
            ? overrideTranslation
            : translation,
          replacements
        );
      }
    }

    return messagePath;
  }

  private replacePlaceholders(
    translation: string,
    replacements?: ReplacementArgs
  ): string {
    if (!replacements) {
      return translation;
    }

    let newTranslation = translation;

    for (const key of Object.keys(replacements)) {
      newTranslation = newTranslation.replace(
        `{${key}}`,
        `${replacements[key]}`
      );
    }

    return newTranslation;
  }
}
